import { IconLayer } from '@deck.gl/layers';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { FsDeckGLOverlay } from '@lib/geo/helpers';
import { FsMap } from '@lib/geo/map';
import { LocaleService } from '@lib/translation';
import { LprCameraModel } from '@lib/vehicle-intelligence/api';

@Component({
  selector: 'fs-lpr-camera-table-expanded',
  templateUrl: './lpr-camera-table-expanded.component.html',
  styleUrls: ['./lpr-camera-table-expanded.component.scss'],
})
export class LprCameraTableExpandedComponent implements OnDestroy, OnInit {
  @Input() public readonly lprCamera: LprCameraModel;

  public map: FsMap;
  public deckLayer: FsDeckGLOverlay;
  public layers: any[] = [];

  constructor(private readonly _localeService: LocaleService) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this.map?.destroy();
  }

  public onMapInit(map: FsMap): void {
    this.map = map;
    this._createOverlay();
  }

  private _createMarker(): void {
    let fontIcon;
    switch (true) {
      case this.lprCamera.provider?.toString() === 'FLOCK_SAFETY':
        fontIcon = 'Icon_FS';
        break;
      case this.lprCamera.provider?.toString().includes('GENETEC'):
      case this.lprCamera.provider?.toString().includes('GENETEC_SHARP3'):
      case this.lprCamera.provider?.toString().includes('GENETEC_SHARP5'):
        fontIcon = 'Icon_Genetec';
        break;
      case this.lprCamera.provider?.toString().includes('VIGILANT'):
        fontIcon = 'Icon_Vigilant';
        break;
      case this.lprCamera.provider?.toString().includes('REKOR'):
        fontIcon = 'Icon_Rekor';
        break;
      default:
        fontIcon = 'FususALPR';
        break;
    }

    const iconLayer = new IconLayer({
      data: [this.lprCamera],
      getIcon: (d) => ({
        url: `/assets/fusus-icons/SVG/${fontIcon}.svg`,
        width: 512,
        height: 512,
      }),
      getPosition: (d) => [this.lprCamera.longitude, this.lprCamera.latitude],
      getSize: 28,
      pickable: true,
    });

    this.layers.push(iconLayer);
    const overlay = this.deckLayer.addLayer(iconLayer);
    this.map.addLayer(overlay);
  }

  private _createOverlay(): void {
    this.deckLayer = new FsDeckGLOverlay();

    this._createMarker();
  }

  public formatCoordinate(value: number): string {
    return this._localeService.formatCoordinate(value);
  }
}
